﻿import { GuiDetailGeneric } from "../../GuiDetailGeneric";
export class GuiDetailAvalTransaction extends GuiDetailGeneric {
    constructor() {
        super("GuiDetailAvalTransaction");
    }
}
